export interface Money {
  currency: string;
  amount: number;
}
export interface Currency {label: string, value: string}
export const currencies: Array<{label: string, value: string}> = [
  {label: '美元', value: 'USD'},
  {label: '元', value: 'RMB'},
  {label: '港元', value: 'HKD'},
  {label: '日元', value: 'JPY'},
  {label: '欧元', value: 'EUR'},
  {label: '英镑', value: 'GBP'},
  {label: '韩元', value: 'KRW'},
  {label: '泰铢', value: 'THB'},
  {label: '印尼盾', value: 'IDR'},
];

